var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3384 8.47476C16.3384 14.2885 8.66432 19.2716 8.66432 19.2716C8.66432 19.2716 0.990234 14.2885 0.990234 8.47476C0.990234 6.49233 1.79875 4.5911 3.23792 3.18931C4.67709 1.78752 6.62903 1 8.66432 1C10.6996 1 12.6515 1.78752 14.0907 3.18931C15.5299 4.5911 16.3384 6.49233 16.3384 8.47476Z",
    stroke: "#FB7C51",
    strokeWidth: 1.31719,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66447 10.5291C10.0772 10.5291 11.2225 9.41355 11.2225 8.03749C11.2225 6.66142 10.0772 5.5459 8.66447 5.5459C7.25171 5.5459 6.10645 6.66142 6.10645 8.03749C6.10645 9.41355 7.25171 10.5291 8.66447 10.5291Z",
    stroke: "#FB7C51",
    strokeWidth: 1.31719,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.0c22a39ad829f1be906a29e2e60a3fdb.svg";
export { ForwardRef as ReactComponent };